// jobsApi.js
import api from '../api'; // Import your configured axios instance

// Helper function to map job data to frontend format
const mapJobToFrontend = (job) => ({
  jobId: job.jobId,
  jobTitle: job.jobTitle,
  position: job.position,
  jobName: job.jobName,
  jobDescription: job.jobDescription,
  city: job.city,
  platform: job.platform,
  postedDate: job.postedDate,
  timeline: job.timeline,
  status: job.status,
});

export const getAllJobs = async () => {
  try {
    const response = await api.get('/jobs');
    // Map backend response to frontend format
    return response.data.map(mapJobToFrontend);
  } catch (error) {
    console.error('Error fetching jobs:', error.response?.data || error.message);
    throw error; // Re-throw to let caller handle it
  }
};

export const createJob = async (jobData) => {
  try {
    const response = await api.post('/jobs', {
      jobTitle: jobData.jobTitle,
      position: jobData.position,
      jobName: jobData.jobName,
      jobDescription: jobData.jobDescription,
      city: jobData.city,
      platform: jobData.platform,
      timeline: jobData.timeline || null,
      status: jobData.status,
    });
    
    return mapJobToFrontend(response.data);
  } catch (error) {
    console.error('Error creating job:', error.response?.data || error.message);
    throw error;
  }
};

export const updateJob = async (jobId, jobData) => {
  try {
    const response = await api.put(`/jobs/${jobId}`, {
      jobTitle: jobData.jobTitle,
      position: jobData.position,
      jobName: jobData.jobName,
      jobDescription: jobData.jobDescription,
      city: jobData.city,
      platform: jobData.platform,
      timeline: jobData.timeline || null,
      status: jobData.status,
    });
    
    return mapJobToFrontend(response.data);
  } catch (error) {
    console.error('Error updating job:', error.response?.data || error.message);
    throw error;
  }
};

export const deleteJob = async (jobId) => {
  try {
    await api.delete(`/jobs/${jobId}`);
  } catch (error) {
    console.error('Error deleting job:', error.response?.data || error.message);
    throw error;
  }
};

export const getJobById = async (jobId) => {
  try {
    const response = await api.get(`/jobs/${jobId}`);
    return mapJobToFrontend(response.data);
  } catch (error) {
    console.error('Error fetching job:', error.response?.data || error.message);
    throw error;
  }
};

export const getTotalJobs = async () => {
  try {
    const response = await api.get('/jobs/count');
    return response.data;
  } catch (error) {
    console.error('Error fetching job count:', error.response?.data || error.message);
    throw error;
  }
};

export const getJobsByStatus = async (status) => {
  try {
    const response = await api.get('/jobs', {
      params: { status }
    });
    return response.data.map(mapJobToFrontend);
  } catch (error) {
    console.error(`Error fetching ${status} jobs:`, error.response?.data || error.message);
    throw error;
  }
};

export const getJobStatistics = async () => {
  try {
    // Try dedicated statistics endpoint first
    const response = await api.get('/jobs/statistics');
    return {
      total: response.data.total || 0,
      posted: response.data.posted || 0,
      expired: response.data.expired || 0
    };
  } catch (error) {
    // Fallback: get all jobs and count by status
    try {
      const allJobs = await getAllJobs();
      const posted = allJobs.filter(job => 
        job.status === 'POSTED' || job.status === 'posted'
      ).length;
      const expired = allJobs.filter(job => 
        job.status === 'EXPIRED' || job.status === 'expired'
      ).length;
      
      return {
        total: allJobs.length,
        posted,
        expired
      };
    } catch (fallbackError) {
      console.error('Error fetching job statistics:', fallbackError);
      return {
        total: 0,
        posted: 0,
        expired: 0
      };
    }
  }
};